
import { createContext, useContext } from 'react';
import { SubscriptionContextType } from './types';

/**
 * React context for subscription management
 * Provides subscription state and actions throughout the application
 */
export const SubscriptionContext = createContext<SubscriptionContextType | undefined>(undefined);

/**
 * Hook to access subscription context
 * Must be used within a SubscriptionProvider
 * 
 * @returns {SubscriptionContextType} Subscription context with state and actions
 * @throws {Error} When used outside of SubscriptionProvider
 */
export const useSubscription = () => {
  const context = useContext(SubscriptionContext);
  if (context === undefined) {
    throw new Error('useSubscription must be used within a SubscriptionProvider');
  }
  return context;
};
